import { jsx as _jsx } from "react/jsx-runtime";
import { FieldSwitch } from '@dixa/lib-shared-habla';
import cn from 'classnames';
import * as React from 'react';
import styles from './index.module.scss';
export const CsatToggle = ({ onChange, isActive, channel, className, id, }) => {
    const handleChange = () => onChange({
        channel: channel,
        newStatus: !isActive,
    });
    return (_jsx(FieldSwitch, { id: id, className: cn(styles.switch, className), input: {
            name: channel,
            value: channel,
            checked: isActive,
            onChange: handleChange,
        } }));
};
